<div class="image">
  <ng-container *ngTemplateOutlet="imageContainer"></ng-container>
  <button
    (click)="close.emit()"
    mat-fab
    >
    <mat-icon>close</mat-icon>
  </button>
  @if (sceneImages.length > 1) {
    <div class="next" (click)="goRight()">
      <mat-icon>
        navigate_next
      </mat-icon>
    </div>
    <div class="prev" (click)="goLeft()">
      <mat-icon>
        navigate_before
      </mat-icon>
    </div>
  }
</div>
<ng-template #imageContainer>
  <ng-container *libIsHandset="desktopView">
    <pinch-zoom
      [auto-zoom-out]="true"
      [disableZoomControl]="'disable'"
      [double-tap-scale]="3"
      [limit-zoom]="3"
      backgroundColor="transparent"
      (swiperight)="goLeft()"
      (swipeleft)="goRight()"

      overflow="visible"
      >
      <lib-print-frame-drawer [ratio]="ratio$ | async" [config]="currentConfig | async" [context]="context"
        [photoId]="photoId$ | async"
        [showScenePicker]="true"
        [currentScene]="currentScene.value"
      [contextId]="contextId"></lib-print-frame-drawer>
    </pinch-zoom>

  </ng-container>

  <ng-template #desktopView>
    <div class="image-container">
      <lib-print-frame-drawer [ratio]="ratio$ | async" [config]="currentConfig | async" [context]="context"
        [photoId]="photoId$ | async"
        [showScenePicker]="true"
        [currentScene]="currentScene.value"
      [contextId]="contextId"></lib-print-frame-drawer>
    </div>
  </ng-template>
  @if (sceneImages.length > 1) {
    <div class="scenePicker">
      @for (scene of sceneImages; track scene; let i = $index) {
        <div
          (click)="currentScene.patchValue(i)"
          [ngClass]="{ active: currentScene.value === i }"
          class="scene"
        ></div>
      }
    </div>
  }
</ng-template>


<div class="controls">
  <div class="menu">
    <div class="frames">
      @for (frame of options$ | async; track trackFrame($index, frame)) {
        <div class="frame"
          [ngClass]="{ picked: frame.value === (currentConfig | async)  }"
          >
          <lib-print-frame-drawer [ratio]="ratio$ | async" [config]="frame.value" [context]="context"
            [photoId]="photoId$ | async"
            [skipImage]="true"
            (click)="currentConfig.next(frame.value)"
          [contextId]="contextId"></lib-print-frame-drawer>
          @if (((photoId$ | async) | getFramesCountInBasket:frame.value | async)=== 0) {
            <div class="addFirst"
              >
              <lib-button icon-only (click)="add(frame.value,frame.price)">
                <mat-icon>add</mat-icon>
              </lib-button>
            </div>
          } @else {
            <div class="counter">
              <lib-button icon-only (click)="remove(frame.value)">
                <mat-icon>remove</mat-icon>
              </lib-button>
              <span>{{(photoId$ | async) | getFramesCountInBasket:frame.value | async}}</span>
              <lib-button icon-only (click)="add(frame.value,frame.price)">
                <mat-icon>add</mat-icon>
              </lib-button>
            </div>
          }
          <div class="details">
            <div class="name">{{frame.value | printFrameName |async }}</div>
            <div class="price">{{frame.price | pricePicker  }}</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
